const getNumberFormatted = (value) => {
    return Intl.NumberFormat('it-IT', { minimumFractionDigits: 2 }).format(value);
}

export default getNumberFormatted;